export default "__VITE_ASSET__DRdo2SxK__"